import { useDispatch } from 'react-redux';

const ADD_TIMEOUT_ID = 'ADD_TIMEOUT_ID';
const REMOVE_TIMEOUT_ID = 'REMOVE_TIMEOUT_ID';
const CLEAR_ALL_IDS = 'CLEAR_ALL_IDS';
const SET_ALERT_SETTINGS = 'SET_ALERT_SETTINGS';

const clearAllIDs = ({ legId }) => {
    return {
        type: CLEAR_ALL_IDS,
        alert: { legId },
    };
};

const useClearAllIDs = () => {
    const dispatch = useDispatch();

    return (legId) => dispatch(clearAllIDs({ legId }));
};

const addTimeoutID = ({ legId, type, timeoutId, date }) => {
    return {
        type: ADD_TIMEOUT_ID,
        alert: { legId, type, timeoutId, date },
    };
};

const useAddTimeoutID = () => {
    const dispatch = useDispatch();

    return ({ legId, type, timeoutId, date }) => dispatch(addTimeoutID({ legId, type, timeoutId, date }));
};

const removeTimeoutID = (legId, alertType) => {
    return {
        type: REMOVE_TIMEOUT_ID,
        alert: { legId, type: alertType },
    };
};

const useRemoveTimeoutID = () => {
    const dispatch = useDispatch();

    return (legId, alertType) => dispatch(removeTimeoutID(legId, alertType));
};

const saveAlertSettings = ({ interval, allowed }) => {
    return {
        type: SET_ALERT_SETTINGS,
        setting: { interval, allowed },
    };
};

const useSaveAlertSettings = () => {
    const dispatch = useDispatch();

    return ({ interval, allowed }) => dispatch(saveAlertSettings({ interval, allowed }));
};

export {
    ADD_TIMEOUT_ID,
    REMOVE_TIMEOUT_ID,
    SET_ALERT_SETTINGS,
    CLEAR_ALL_IDS,
    clearAllIDs,
    useAddTimeoutID,
    useRemoveTimeoutID,
    useSaveAlertSettings,
    useClearAllIDs,
};
